import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
var Qt = /*#__PURE__*/function () {
  function Qt(s) {
    _classCallCheck(this, Qt);
    this.id = s, this.id = s;
  }
  _createClass(Qt, [{
    key: "Ar",
    value: function Ar() {
      var s = {};
      return null != this.browser && (s.browser = this.browser), null != this.Ga && (s.browser_version = this.Ga), null != this.os && (s.os_version = this.os), null != this.resolution && (s.resolution = this.resolution), null != this.language && (s.locale = this.language), null != this.timeZone && (s.time_zone = this.timeZone), null != this.userAgent && (s.user_agent = this.userAgent), s;
    }
  }]);
  return Qt;
}();
export { Qt as default };